module.exports = __webpack_public_path__ + "img/Squirrel.0f0d2ac9.jpg";